import { BooleanInput, Create, NumberInput, required, TabbedForm, TextInput } from 'react-admin';
import { Box, Grid2 as Grid } from '@mui/material';
import { ProductResource } from '../../Entities/Product';
import { ReactElement } from 'react';
import JsonApiHasOneReferenceInput from '../../Components/JsonApiHasOneReferenceInput';
import { CurrencyAmountInput } from '../../Components/CurrencyAmount/CurrencyAmountInput';
import ImageUrlInput from '../../Components/ImageUrlInput';
import ProductLabelsTab from './LabelsTab';
import ProductToolbar from './Toolbar';

export default function ProductCreate(): ReactElement {
  return (
    <Create<ProductResource>>
      <TabbedForm toolbar={<ProductToolbar mode="create" />}>
        <TabbedForm.Tab label="Details">
          <Grid container spacing={2} sx={{ width: '100%' }}>
            <Grid size={{ xs: 12, xl: 4 }}>
              <Box flex={1}>
                <TextInput label="Name" source="attributes.name" fullWidth />
              </Box>
              <Box flex={1}>
                <TextInput label="Custom Title" source="attributes.custom_title" fullWidth />
              </Box>
              <Box>
                <TextInput label="Model" source="attributes.model" fullWidth />
              </Box>
              <Box flex={1}>
                <JsonApiHasOneReferenceInput<ProductResource, 'manufacturer', 'manufacturers'>
                  label="Manufacturer"
                  optionText="attributes.name"
                  source="relationships.manufacturer"
                  reference="manufacturers"
                  isRequired
                  validate={[required()]}
                />
              </Box>
              <Box flex={1}>
                <TextInput
                  label="Description"
                  source="attributes.description"
                  multiline
                  fullWidth
                />
              </Box>
              <Box flex={1}>
                <TextInput label="Keywords" source="attributes.keywords" multiline fullWidth />
              </Box>
              <Box flex={1}>
                <JsonApiHasOneReferenceInput<ProductResource, 'category', 'categories'>
                  label="Category"
                  optionText="attributes.full_name"
                  source="relationships.category"
                  reference="categories"
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, xl: 2 }}>
              <CurrencyAmountInput
                label="Min Price (AUD)"
                source="attributes.min_price"
                step={0.01}
                fullWidth
              />
              <CurrencyAmountInput
                label="Max Price (AUD)"
                source="attributes.max_price"
                step={0.01}
                fullWidth
              />
              <NumberInput
                label="Future Publishing ID"
                source="attributes.future_publishing_id"
                fullWidth
              />
              <TextInput label="MPN" source="attributes.mpn" fullWidth />
              <TextInput label="UPC" source="attributes.upc" fullWidth />
            </Grid>
            <Grid size={{ xs: 12, xl: 6 }}>
              <BooleanInput label="Active?" source="attributes.status" />
              <BooleanInput label="Is Prioritized?" source="attributes.is_prioritized" />
              <ImageUrlInput label="Image" source="attributes.image_url" />
            </Grid>
          </Grid>
        </TabbedForm.Tab>
        <ProductLabelsTab />
      </TabbedForm>
    </Create>
  );
}
